import { Link, createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { Card } from "../components/ui";
import { LoginForm } from "../features/auth/LoginForm";
import { safeRedirect } from "../features/auth/redirect";
import { loadMe, meQueryOptions } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

const searchSchema = z.object({ redirect: z.string().optional() });

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, search }) => {
    const me = await loadMe(context.queryClient);
    if (me) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: LoginPage,
});

function LoginPage() {
  const t = useT();
  const navigate = useNavigate();
  const { redirect: target } = Route.useSearch();
  const { queryClient } = Route.useRouteContext();
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.login.title")}>
        <LoginForm
          onSignedIn={async () => {
            queryClient.removeQueries({ queryKey: meQueryOptions().queryKey });
            await navigate({ href: safeRedirect(target) });
          }}
          onTwoFactorRequired={(method) =>
            void navigate({ to: "/two-factor", search: { redirect: target, method } })
          }
        />
        <p className="mt-4 flex flex-col gap-1 text-sm">
          <Link to="/forgot-password">{t("auth.login.forgot")}</Link>
          <span>
            {t("auth.login.noAccount")} <Link to="/register">{t("nav.register")}</Link>
          </span>
        </p>
      </Card>
    </main>
  );
}
